export default {
  SET_MODAL_STATE(state, newModalState) {
    state.modalState = newModalState
  },
  SET_EMERGE_MODE(state, newMode) {
    state.emergeMode = newMode
  }
}
